
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export const useApproveStrategy = (loadStrategiesCallback: () => Promise<void>) => {
  const [isApproving, setIsApproving] = useState(false);
  const { toast } = useToast();

  const approveStrategy = async (strategyId: string, approved: boolean) => {
    setIsApproving(true);
    try {
      const { error } = await supabase
        .rpc('approve_strategy', {
          strategy_id: strategyId,
          approval_status: approved
        });

      if (error) throw error;

      toast({
        title: "Success",
        description: `Strategy has been ${approved ? 'approved' : 'unapproved'}`,
      });

      await loadStrategiesCallback();
    } catch (error) {
      console.error('Error approving strategy:', error);
      toast({
        title: "Error",
        description: "Failed to update approval status",
        variant: "destructive",
      });
    } finally {
      setIsApproving(false);
    }
  };

  return { approveStrategy, isApproving };
};
